module.exports = __webpack_public_path__ + "img/PeepsCatchesFly.23445ca1.svg";